import { UserId } from '@contexts/Estate';
import { AuthenticatedUser } from '../../models';

export class UserByIdQuery {
  public readonly _tag = 'UserByIdQuery';

  constructor(public readonly user: UserId) {}
}

export class UserByIdResponse {
  public readonly _tag = 'UserByIdResponse';

  constructor(public readonly user: AuthenticatedUser) {}
}
